import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-3 mt-1">
      <div className="container">
        <p className="text-center mb-0 small">
          &copy; {new Date().getFullYear()} E Seller Support — All Rights Reserved
        </p>
      </div>
    </footer>

  )
}

export default Footer
